import { MoodType } from './containers/Stats/Logic/MoodStatsLogic';

export default {
  sizes: {
    minScreenWidth: '1000px',
    smallScreenWidth: '1150px',
    headerHeight: '60px',
  },
  borderRadius: {
    default: '3px',
    MD: '4px',
    LG: '6px',
    Modal: '10px',
    Button: '100px',
  },
  colorGrey: '#8d9da1',
  colorLightGrey: '#dae9ef',
  colorCerulean: '#00a2dd',
  color: {
    white: '#fff',
    color: '#ff5e3c',
    grey: '#8d9da1',
    lightGrey: '#dae9ef',
    cerulean: '#00a2dd',
    battleshipGrey: '#5d747a',
    paleGrey: '#f2f6f7',
    paleGreyTwo: '#fafcfc',
    gunMetal: '#455154',
    black: '#111',
    black2: '#16161d',
    darkBlue: '#212b36',
    blue: '#4469b0',
    greenBlue: '#2ad287',
    border: '#dde6ea',
    coral: `#ff5e3c`,
    paleBlue: '#dce6ea',
    butterscotch: '#ffc638',
    warmBlue: '#4b63e3',
    burntSienna: '#e97451',
    romanticRose: '#eb5569',
    shameEmotion: '#ff8a80',
    lavender: '#e6beff',
    teaGreen: '#d0f0c0',
    getBarColor(value: MoodType): string {
      switch (value) {
        case MoodType.positive:
          return this.greenBlue;
        case MoodType.negative:
          return this.coral;
        case MoodType.neutral:
          return this.paleBlue;
      }
    },
  },
  font: {
    primary: '-apple-system, \'SF Pro Text\', "Helvetica Neue", sans-serif',
    secondary: "'Lora', serif",
    size: {
      xSmall: '12px',
      small: '14px',
      regular: '16px',
      large: '21px',
      XLarge: '24px',
      XXLarge: '30px',
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
  },
};



// WEBPACK FOOTER //
// ./src/Theme.ts